"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var calculateArrowCoords = function calculateArrowCoords(elem, popup, placement, arrowPointAtCenter, popupContainer) {
  var arrowCoords = {
    left: '50%',
    top: '50%'
  };

  if (arrowPointAtCenter) {
    return arrowCoords;
  }

  var elemCoords = elem.getBoundingClientRect();
  var popupCoords = popup.getBoundingClientRect();

  switch (placement) {
    case 'left':
    case 'right':
      arrowCoords.top = '50%';
      return arrowCoords;

    case 'top':
    case 'bottom':
      arrowCoords.left = '50%';
      return arrowCoords;

    case 'topLeft':
    case 'bottomLeft':
      arrowCoords.left = '12px';
      return arrowCoords;

    case 'topRight':
    case 'bottomRight':
      arrowCoords.left = 'calc(100% - 12px)';
      return arrowCoords;

    case 'leftTop':
    case 'rightTop':
      arrowCoords.top = '12px';
      return arrowCoords;

    case 'leftBottom':
    case 'rightBottom':
      arrowCoords.top = 'calc(100% - 12px)';
      return arrowCoords;

    default:
      {
        var isContainerBody = popupContainer.tagName === 'BODY';
        var centerCoords = elemCoords.left + (elemCoords.width / 2 - popupCoords.width / 2);

        if (isContainerBody) {
          if (centerCoords < 0 || centerCoords + popupCoords.width > window.innerWidth) {
            if (elemCoords.left + elemCoords.width > window.innerWidth) {
              arrowCoords.left = 'calc(100% - 12px)';
              return arrowCoords;
            }

            if (elemCoords.left < 0) {
              arrowCoords.left = '12px';
              return arrowCoords;
            }
          }

          return arrowCoords;
        }

        var containerCoords = popupContainer.getBoundingClientRect();

        if (centerCoords < containerCoords.left || centerCoords + popupCoords.width > containerCoords.left + containerCoords.width) {
          if (elemCoords.left + popupCoords.width > containerCoords.left + containerCoords.width) {
            arrowCoords.left = 'calc(100% - 12px)';
            return arrowCoords;
          }

          if (elemCoords.left < containerCoords.left) {
            arrowCoords.left = '12px';
            return arrowCoords;
          }
        }

        return arrowCoords;
      }
  }
};

var _default = calculateArrowCoords;
exports.default = _default;